// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"df8b5ccd","749":"68c78786","903":"e88982ae","959":"9b23d071"}[chunkId] + ".chunk.js";
};